import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { firstValueFrom, map } from 'rxjs';
import { BookingService } from '@markant-platform/cartridge/data-access';
import { BookingDataDetails } from '@markant-platform/cartridge/model';
import { isBulkPrice } from '@markant-platform/shared/util-helpers';
import { SnackbarService } from '@markant-platform/shared/snackbar/feature';

export const UsageReportGuard: CanActivateFn = async (route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> => {
  const router: Router = inject(Router);
  const bookingService: BookingService = inject(BookingService);
  const snackbarService: SnackbarService = inject(SnackbarService);

  const bookingId = route.paramMap.get('bookingId') as string;
  const organizationId = route.paramMap.get('organizationId') as string;
  const cartridgeVariantId = route.paramMap.get('cartridgeId') as string;

  const booking: BookingDataDetails = await firstValueFrom(
    !bookingId
      ? bookingService
          .getBookingRequests(1, 0, `organizationId=${organizationId}&variantId=${cartridgeVariantId}&state=BOOKED`)
          .pipe(map(({ result }) => result[0]))
      : bookingService.getBookingById(bookingId)
  );

  if (!isBulkPrice(booking.price)) {
    snackbarService.showErrorSnackbarWithTransloco('usage.report.unsupported');
    return router.parseUrl('/');
  }

  return true;
};
